import "core-js/modules/es.array.reverse.js";
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.exec.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, runInAction, makeObservable } from "mobx";
import containsAny from "../../../Core/containsAny";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import runLater from "../../../Core/runLater";
import { networkRequestError } from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GetCapabilitiesMixin from "../../../ModelMixins/GetCapabilitiesMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import WebMapTileServiceCatalogGroupTraits from "../../../Traits/TraitsClasses/WebMapTileServiceCatalogGroupTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import WebMapTileServiceCapabilities from "./WebMapTileServiceCapabilities";
import WebMapTileServiceCatalogItem from "./WebMapTileServiceCatalogItem";
let GetCapabilitiesStratum = (_class = class GetCapabilitiesStratum extends LoadableStratum(WebMapTileServiceCatalogGroupTraits) {
  static async load(catalogItem) {
    if (catalogItem.getCapabilitiesUrl === undefined) {
      throw networkRequestError({
        title: i18next.t("models.webMapTileServiceCatalogGroup.invalidWMTSServerTitle"),
        message: i18next.t("models.webMapTileServiceCatalogGroup.invalidWMTSServerMessage", this)
      });
    }
    const capabilities = await WebMapTileServiceCapabilities.fromUrl(proxyCatalogItemUrl(catalogItem, catalogItem.getCapabilitiesUrl, catalogItem.getCapabilitiesCacheDuration));
    return new GetCapabilitiesStratum(catalogItem, capabilities);
  }
  constructor(catalogGroup, capabilities) {
    super();
    this.catalogGroup = catalogGroup;
    this.capabilities = capabilities;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new GetCapabilitiesStratum(model, this.capabilities);
  }
  get name() {
    if (this.capabilities && this.capabilities.ServiceIdentification && this.capabilities.ServiceIdentification.Title) {
      return replaceUnderscores(this.capabilities.ServiceIdentification.Title);
    }
  }
  get info() {
    const result = [];
    const service = this.capabilities.ServiceIdentification;
    if (!isDefined(service)) {
      return result;
    }
    if (service.Abstract && !containsAny(service.Abstract, WebMapTileServiceCatalogItem.abstractsToIgnore)) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webMapTileServiceCatalogGroup.abstract"),
        content: service.Abstract
      }));
    }
    if (service.AccessConstraints && !/^none$/i.test(service.AccessConstraints)) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webMapTileServiceCatalogGroup.accessConstraints"),
        content: service.AccessConstraints
      }));
    }

    // Show the Fees if it isn't "none".
    if (service.Fees && !/^none$/i.test(service.Fees)) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webMapTileServiceCatalogGroup.fees"),
        content: service.Fees
      }));
    }
    return result;
  }

  // Show the Access Constraints if it isn't "none" (because that's the default, and usually a lie).

  get members() {
    return filterOutUndefined(this.capabilities.layers.map(layer => this.getLayerId(layer)));
  }
  createMembersFromLayers() {
    this.capabilities.layers.forEach(layer => this.createMemberFromLayer(layer));
  }
  createMemberFromLayer(layer) {
    const layerId = this.getLayerId(layer);
    if (!layerId) {
      return;
    }

    // Create model for WMTSCatalogItem
    const existingModel = this.catalogGroup.terria.getModelById(WebMapTileServiceCatalogItem, layerId);
    let model;
    if (existingModel === undefined) {
      model = new WebMapTileServiceCatalogItem(layerId, this.catalogGroup.terria);
      this.catalogGroup.terria.addModel(model);
    } else {
      model = existingModel;
    }

    // Replace the stratum inherited from the parent group.
    model.strata.delete(CommonStrata.definition);
    model.setTrait(CommonStrata.definition, "name", layer.Title);
    model.setTrait(CommonStrata.definition, "url", this.catalogGroup.url);
    model.setTrait(CommonStrata.definition, "getCapabilitiesUrl", this.catalogGroup.getCapabilitiesUrl);
    model.setTrait(CommonStrata.definition, "getCapabilitiesCacheDuration", this.catalogGroup.getCapabilitiesCacheDuration);
    model.setTrait(CommonStrata.definition, "layer", layer.Title);
    model.setTrait(CommonStrata.definition, "hideSource", this.catalogGroup.hideSource);
    model.setTrait(CommonStrata.definition, "isOpenInWorkbench", this.catalogGroup.isOpenInWorkbench);
    model.setTrait(CommonStrata.definition, "isExperiencingIssues", this.catalogGroup.isExperiencingIssues);
    model.createGetCapabilitiesStratumFromParent(this.capabilities);
  }
  getLayerId(layer) {
    if (!isDefined(this.catalogGroup.uniqueId)) {
      return;
    }
    return "".concat(this.catalogGroup.uniqueId, "/").concat(layer.Title || layer.Identifier);
  }
}, _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMembersFromLayers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMembersFromLayers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberFromLayer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberFromLayer"), _class.prototype), _class);
export default class WebMapTileServiceCatalogGroup extends GetCapabilitiesMixin(UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(WebMapTileServiceCatalogGroupTraits))))) {
  get type() {
    return WebMapTileServiceCatalogGroup.type;
  }
  async forceLoadMetadata() {
    if (this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName) !== undefined) return;
    const stratum = await GetCapabilitiesStratum.load(this);
    runInAction(() => {
      this.strata.set(GetCapabilitiesMixin.getCapabilitiesStratumName, stratum);
    });
  }
  async forceLoadMembers() {
    const getCapabilitiesStratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (getCapabilitiesStratum) {
      await runLater(() => getCapabilitiesStratum.createMembersFromLayers());
    }
  }
  get defaultGetCapabilitiesUrl() {
    if (this.uri) {
      return this.uri.clone().setSearch({
        service: "WMTS",
        version: "1.0.0",
        request: "GetCapabilities"
      }).toString();
    } else {
      return undefined;
    }
  }
}
_defineProperty(WebMapTileServiceCatalogGroup, "type", "wmts-group");